<button
  [id]="id"
  [ngClass]="class + ' ' + extraClasses"
  [type]="type"
  [disabled]="disabled"
  [attr.aria-label]="accessibleLabel"
  (click)="onClick.emit($event)"
>
  <ng-content></ng-content>
  <i *ngIf="iconClass" [ngClass]="iconClass" [style]="iconStyle"></i>
  <img *ngIf="imageSrc" [src]="imageSrc" [style]="imageStyle" [alt]="imageAlt" class="img-fluid">
</button>